<template>
  <div :style="{ backgroundImage: 'url(' + backUrl + ')' }" class="aui-flexView">

    <div class="aui-scrollView">
      <div class="aui-account-title">
        <h1>选&nbsp;手&nbsp;验&nbsp;证</h1>
      </div>
      <div class="aui-account-input">
        <div style="margin-top: 3rem;text-align: center">
          <el-input type="text" v-model="name" placeholder="请输入选手姓名"></el-input>
        </div>
        <div style="margin-top: 1.5rem">
          <el-input type="text" v-model="idcard" placeholder="请输入选手身份证号码"></el-input>
        </div>
        <!--        <div style="margin-top: 2rem">-->
        <!--          <el-input type="text" v-model="phone" placeholder="请输入选手手机号"></el-input>-->
        <!--        </div>-->
      </div>
      <div class="aui-account-button" @click="loginFn">
        <button>验&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;证</button>
      </div>
      <p class="err-message">{{ errMessage }}</p>

      <!--      <div class="aui-account-footer">-->
      <!--        <div class="aui-account-footer-title">-->
      <!--          官网地址-->
      <!--        </div>-->
      <!--        <div class="aui-palace">-->
      <!--          <a href="http://www.china-swordfish.com/" style="color:#FFFFFF" target="_blank">{{-->
      <!--              $t('login.helpCenter')-->
      <!--            }}</a>-->
      <!--          <a href="http://www.china-swordfish.com/" style="color:#FFFFFF" target="_blank">{{-->
      <!--              $t('login.cialWebsite')-->
      <!--            }}</a>-->
      <!--        </div>-->
      <!--      </div>-->


    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      url: '/api/check/player/login',
      matchurl: '/api/match/get',
      name: '', // localStorage.getItem('loginName'),
      idcard: '', // localStorage.getItem('loginName'),
      phone: '',
      marathonId: '',
      errMessage: '',
      rememberFlag: 'zh', // localStorage.getItem('rememberFlag'),
      langFlag: false,
      currentLang: '',
      random: 1,
      backUrl: "",
    };
  },
  created() {
    this.marathonId = this.$route.fullPath.substring(this.$route.fullPath.lastIndexOf("?") + 1)
    sessionStorage.setItem('marathonId', this.marathonId);
    if (this.marathonId) {
      this.$axios.get(
          this.matchurl,
          {
            params: {
              marathonId: this.marathonId
            }
          }
      ).then(res => {
        if (res.data.succeeded) {
          if (res.data.obj.backUrl){
            this.backUrl = res.data.obj.backUrl
          }
        }else {
          this.backUrl = "https://jianyutiyu.oss-cn-beijing.aliyuncs.com/img/声明/e6d488de-11f1-434d-9f30-c46c785211b1bg.png"
        }
      }).catch(error => {

      });
    }
  },
  methods: {
    loginFn() { // 登录事件
      this._confirmLogin();
    },
    _confirmLogin() {
      if (!this.marathonId) {
        this.$message({
          type: 'danger',
          message:"请重新扫码"
        });
        return;
      }
      if (!this.idcard || !this.name) {
        this.$message({
          type: 'error',
          message:"请输入完整的选手信息"
        });
        return;
      } else {
        this.errMessage = ""
      }

      this.$axios.post(
          this.url,
          {
            marathonId: this.marathonId,
            playerPhone: this.phone,
            playerIdNumber: this.idcard,
            playerName: this.name
          }
      ).then(res => {
        if (res.data.succeeded) {
          sessionStorage.setItem('token', res.data.obj.token);
          this.$router.push({path: '/dateScreen'});
        } else {
          this.$message({
            type: 'danger',
            message: res.data.msg
          });
        }
      }).catch(error => {
      });
    }
  },
  computed: {}
};
</script>

<style scoped>
.aui-flexView {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("https://img-blog.csdnimg.cn/166e183e84094c44bbc8ad66500cef5b.jpeg");
  background-size: cover;
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.aui-scrollView {
  width: 100%;
  height: 100%;
  padding-top: 30%;
}


.slider-item img {
  width: 100%;
  height: auto;
  display: block;
  border: none;
}


.aui-palace-grid-icon img {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}


.aui-palace-grid-text h2 {
  font-size: 0.8rem;
  font-weight: normal;
  color: #666666;
}


.aui-account-title {
  text-align: center;
}

.aui-account-title h1 {
  color: black;
  font-size: 3.2rem;
}

.aui-account-input {
  width: 91%;
//background:#fff; border-radius: 2px; margin: 0 auto; overflow: hidden; padding: 0;
}


.aui-account-input el-input {
  height: 10rem;
  line-height: 2.8rem;
  padding: 0.8rem 1rem;
  font-size: 3.85rem;
  color: #333;
  border: none;
  width: 100%;
}

.aui-account-button {
  background: #DC2625;
  width: 91%;
  margin: 1.5rem auto;
  overflow: hidden;
  padding: 0.5rem 0;
  text-align: center;
}

.aui-account-button button {
  color: white;
  text-align: center;
  border: none;
  background: #DC2625;
  display: block;
  width: 100%;
  font-size: 1rem;
}

</style>





// WEBPACK FOOTER //
// src/views/login.vue